import React from "react";
import { CarouselModal } from "@src/lms/jelly/extensions/layouts/_lesson/case7/common/components/CarouselModal";
import { useIntl } from "react-intl";
import * as appConfig from "appConfig";

import styles from "./MixingStage.module.scss";
import { useUi } from "@jelly/lesson";
import { messages } from "../../Preparations.messages";

type MixingStageModalProps = Omit<React.ComponentProps<typeof CarouselModal>, "children">;

export const MixingStageModal: React.FC<MixingStageModalProps> = (props) => {
  const { formatMessage } = useIntl();
  const ui = useUi();

  return (
    <ui.Modal {...props}>
      <div className={styles.slide}>
        <div className={styles.content}>
          <h2 className={styles.title}>{formatMessage(messages.mixingStageModalTitle)}</h2>
          <p className={styles.description}>{formatMessage(messages.mixingStageModalDescription)}</p>
        </div>
        <div className={styles.divider}></div>
        <div className={styles.imageContainer}>
          <img
            className={styles.image}
            src={`${appConfig.STATIC_ASSETS_URL}/lms/guide/guide03/preparations/2.jpg`}
            alt="feature-comparison"
          />
        </div>
      </div>
    </ui.Modal>
  );
};
